import { applyMiddleware, compose, createStore } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import createSagaMiddleware from "redux-saga";
import rootReducer from "./reducers";
import rootSaga from "./sagas";
import getConfig from "next/config";

const { publicRuntimeConfig } = getConfig();

const CURRENT_VERSION = publicRuntimeConfig.appVersion;

let storage;
if (typeof window !== "undefined") {
  const createIndexedDBStorage = require("redux-persist-indexeddb-storage").default;
  storage = createIndexedDBStorage("simple-blog");
} else {
  storage = {
    getItem: () => Promise.resolve(null),
    setItem: (_key, value) => Promise.resolve(value),
    removeItem: () => Promise.resolve(),
  };
}

const persistConfig = {
  key: "root",
  storage,
  version: 1,
  migrate: async (state) => {
    if (typeof window !== "undefined") {
      const savedVersion = localStorage.getItem("redux_version");

      if (savedVersion !== CURRENT_VERSION) {
        console.log("Version change detected, resetting store...");
        localStorage.setItem("redux_version", CURRENT_VERSION);
        return undefined;
      }

      return state;
    }

    return state;
  },
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
const sagaMiddleware = createSagaMiddleware();

const composeEnhancers =
  (typeof window !== "undefined" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const store = createStore(
  persistedReducer,
  {},
  composeEnhancers(applyMiddleware(sagaMiddleware))
);

const persistor = persistStore(store);

sagaMiddleware.run(rootSaga);

export { persistor, store };
